import { useFocusEffect } from '@react-navigation/native';
import React, { useEffect } from 'react';
import { BackHandler, Platform } from 'react-native';

// MOBILE ANDROID
export const useCustomNavigationBack = (onBackPress: () => boolean) => {
  useFocusEffect(
    React.useCallback(() => {
      if (Platform.OS === 'android') {
        const subscription = BackHandler.addEventListener('hardwareBackPress', () => onBackPress());
        return () => subscription.remove();
      }
    }, [onBackPress]),
  );
};

// WEB
export const useCustomBackNavigation = (onBackPress: () => boolean) => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (typeof onBackPress === 'function') {
        onBackPress();
      }
      return null;
    };

    if (Platform.OS === 'web') {
      window.addEventListener('popstate', () => handleBeforeUnload());
    }

    return () => {
      if (Platform.OS === 'web') {
        window.removeEventListener('popstate', () => handleBeforeUnload());
      }
    };
  }, []);
};
